import {useRef, useEffect, useState, ReactNode} from 'react';

import {AuditDataAssetsV2Body} from '../../types/AuditDataAssetsV2Body';
import {TConditionForm} from '../../types/ConditionTypes';
import {FormApi} from '../FinalForm/types/FormApi';
import {ConditionAssets, OnVehicleCreate} from './types/TVehicleCreateContext';
import {VehicleCreate} from './VehicleCreateCtx';

type VehicleCreateContextProps = {
  children: ReactNode;
  onCreate?: OnVehicleCreate;
  onClose?: () => void;
  onConditionFormChange?: (form: FormApi<TConditionForm> | null) => void;
  onConditionAssetsChange?: (assets: ConditionAssets) => void;
};
export const VehicleCreateContext = ({
  children,
  onCreate,
  onClose,
  onConditionFormChange,
  onConditionAssetsChange,
}: VehicleCreateContextProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const scrollingAreaRef = useRef<HTMLDivElement>(null);
  const [conditionAssets, setConditionAssets] = useState<ConditionAssets>({});

  const pushConditionAsset = (imageId: string, asset: AuditDataAssetsV2Body) => {
    conditionAssets[imageId] = asset;
    setConditionAssets(conditionAssets);
    onConditionAssetsChange?.(conditionAssets);
  };

  const deleteConditionAsset = (imageId: string) => {
    delete conditionAssets[imageId];
    setConditionAssets(conditionAssets);
    onConditionAssetsChange?.(conditionAssets);
  };

  const getConditionAssets = (): ConditionAssets => conditionAssets;

  const conditionForm = useRef<FormApi<TConditionForm> | null>(null);

  const setConditionForm = (_conditionForm: FormApi<TConditionForm> | null) => {
    conditionForm.current = _conditionForm;
    onConditionFormChange?.(conditionForm.current);
  };

  const getConditionForm = (): FormApi<TConditionForm> | null => conditionForm.current;

  useEffect(() => {
    if (scrollingAreaRef.current) {
      scrollingAreaRef.current.scroll(0, 0);
    }
  }, [tabIndex]);

  return (
    <VehicleCreate.Provider
      value={{
        getConditionForm,
        setConditionForm,

        onCreate,
        onClose,

        pushConditionAsset,
        deleteConditionAsset,
        getConditionAssets,

        tabIndex,
        setTabIndex,
        scrollingAreaRef,
      }}
    >
      {children}
    </VehicleCreate.Provider>
  );
};
